import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const InsiderEnrollmentPaymentFlowPage = lazy(
  () => import("../../pages/InsiderEnrollmentPaymentFlowPage")
);
const UnifiedProgressTrackerPage = lazy(
  () => import("../../pages/UnifiedProgressTracker")
);

export function MarinaLiuRoutes() {
  return (
    <Switch>
      <Route
        path="/ml/unified-progress-tracker"
        component={UnifiedProgressTrackerPage}
      />
      <Route
        path="/ml/insider-enrollment-payment-flow"
        component={InsiderEnrollmentPaymentFlowPage}
      />
    </Switch>
  );
}

export const slug = "ml";
